import assign from 'lodash/assign'

import Dashboard from 'components/admin/Dashboard.vue'

import GroupEdit from 'components/admin/group/GroupEdit.vue'
import GroupList from 'components/admin/group/GroupList.vue'

import ConfigDepartment from 'components/admin/department/ConfigDepartment.vue'
import Department from 'components/admin/department/Department.vue'

import AdminPlanList from 'components/plan/AdminPlanList.vue'

import AdminCollectionList from 'components/collection/AdminCollectionList.vue'
import AdminCollectionEdit from 'components/collection/AdminCollectionEdit.vue'
import AdminCollectionView from 'components/collection/AdminCollectionView.vue'

import FileCenter from 'components/file/FileCenter.vue'
import FileEdit from 'components/file/FileEdit.vue'

import { admin_account_map, admin_account_routes } from './account'
import { admin_achievement_map, admin_achievement_routes } from './achievement'
import { admin_notice_map, admin_notice_routes } from './notice'

export * from './account'
export * from './achievement'
export * from './notice'

// 管理端首页
export let admin_dashboard = {
  path: 'dashboard',
  component: Dashboard,
}

// 后台班级管理
export let admin_group = {
  path: 'group/list',
  component: GroupList,
  meta: {auth: $user => !$user.$$is_teacher || $user.$$auth.admin_group},
}
export let admin_group_edit = {
  path: 'group/edit',
  component: GroupEdit,
  meta: {auth: $user => !$user.$$is_teacher || $user.$$auth.admin_group},
}
// 后台部门管理
export let admin_department_config = {
  path: 'department/config',
  component: ConfigDepartment,
  meta: {auth: $user => $user.$$is_super || $user.$$auth.admin_department},
}
export let admin_department = {
  path: 'department',
  component: Department,
  meta: {auth: $user => $user.$$is_super || $user.$$auth.admin_department},
}
// 后台教学计划收集
export let admin_plan_list = {
  path: 'plan/list',
  component: AdminPlanList,
  meta: {auth: $user => $user.$$auth.admin_plan},
}
// 后台收集任务
export let admin_collection_edit = {
  path: 'collection/edit',
  component: AdminCollectionEdit,
  meta: {auth: $user => $user.$$roles.manager && $user.$$auth.admin_plan},
}
export let admin_collection_list = {
  path: 'collection/list',
  component: AdminCollectionList,
  meta: {auth: $user => $user.$$roles.manager && $user.$$auth.admin_plan},
}
export let admin_collection_view = {
  path: 'collection/view',
  component: AdminCollectionView,
  meta: {auth: $user => $user.$$roles.manager && $user.$$auth.admin_plan},
}
// 后台文件共享管理
export let admin_file_center = {
  path: 'file/center',
  component: FileCenter,
}
export let admin_file_edit = {
  path: 'file/edit',
  component: FileEdit,
}

export let admin_routes = [
  admin_dashboard,
  ...admin_account_routes,
  admin_group,
  admin_group_edit,
  admin_department_config,
  admin_department,
  admin_plan_list,
  admin_collection_list,
  admin_collection_edit,
  admin_collection_view,
  admin_file_center,
  admin_file_edit,
  ...admin_achievement_routes,
  ...admin_notice_routes,
]

export let admin_map = assign({
  admin_dashboard,
  admin_group,
  admin_group_edit,
  admin_department_config,
  admin_department,
  admin_plan_list,
  admin_collection_list,
  admin_collection_edit,
  admin_collection_view,
  admin_file_center,
  admin_file_edit,
}, admin_account_map, admin_achievement_map, admin_notice_map)



// WEBPACK FOOTER //
// ./src/router/routes/admin/index.js